import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BusinessModel } from '../../../@models';
import { BaseProductModel } from '../../../@models/erp/baseProduct';
import { CompilationModel } from '../../../@models/erp/compilation';
import { FinishedProductModel } from '../../../@models/erp/finishedProduct';

export enum EWizardAction {
  showBaseProduct = 1,
  showFinishedProduct,
  newFinishedProduct,
  showPriceMatrix,
  finalize,
  genLineItemsFromFinishedProducts,
  baseProductPriceMatrix,
  close,
}
export class WizardAction {
  constructor(public action: EWizardAction, public data: any) {}
}

enum EShowPage {
  baseProduct = 1,
  finishedProduct,
  priceMatrix,
  baseProductMatrix,
}

@Component({
  selector: 'ngx-product-wizard',
  templateUrl: './product-wizard.component.html',
  styleUrls: ['./product-wizard.component.scss'],
})
export class ProductWizardComponent implements OnInit {

  @Input() show: boolean = false;
  @Input() compilation: CompilationModel;
  @Output() showChange = new EventEmitter<boolean>()
  @Output() onFinishedProduct = new EventEmitter<FinishedProductModel>()
  @Output() onFinishedProducts = new EventEmitter<FinishedProductModel[]>()
  @Output() onClose = new EventEmitter()

  @Input() productWizard = false;
  @Input() offerWizard = false;

  eShowPage = EShowPage;
  showPage: EShowPage = EShowPage.baseProduct;
  baseProduct: BaseProductModel;
  finishedProduct: FinishedProductModel;
  finishedProducts: FinishedProductModel[];
  productData: { finishedProduct: FinishedProductModel, issuer: number };
  trialNumber: string;
  newBaseProduct: BaseProductModel;
  customer: BusinessModel;
  supplier: BusinessModel;

  constructor() { }

  ngOnInit() {
  }

  close() {
    this.show = false;
    this.showChange.emit(false);
    this.showPage = EShowPage.baseProduct;
    this.baseProduct = null;
    this.onClose.emit();
  }

  wizardAction(event: WizardAction) {
    console.log('wizard action: ', event);
    switch (event.action) {
      case EWizardAction.newFinishedProduct:
        this.showPage = EShowPage.finishedProduct
        this.finishedProduct = undefined;
        this.baseProduct = event.data;
        break;
      case EWizardAction.showBaseProduct:
        this.showPage = EShowPage.baseProduct;
        this.baseProduct = event.data;
        break;
      case EWizardAction.showFinishedProduct:
        this.showPage = EShowPage.finishedProduct;
        this.finishedProduct = event.data;
        break;
      case EWizardAction.showPriceMatrix:
        this.showPage = EShowPage.priceMatrix;
        this.finishedProduct = event.data;
        break;
      case EWizardAction.baseProductPriceMatrix:
        this.showPage = EShowPage.baseProductMatrix;
        this.baseProduct = event.data && event.data.baseProduct;
        this.finishedProducts = event.data && event.data.finishedProducts;
        this.newBaseProduct = event.data && event.data.newBaseProduct;
        this.customer = event.data.customer;
        this.supplier = event.data.supplier;
        // console.log('event data', event.data, this.customer, this.supplier);
        break;

      case EWizardAction.close:
        this.close();
        break;
      case EWizardAction.finalize:
        this.close();
        this.onFinishedProduct.emit(event.data);
        console.log('genLineItemsFromFinishedProduct', event);
        this.onClose.emit();
        break;
      case EWizardAction.genLineItemsFromFinishedProducts:
        this.close();
        this.onFinishedProducts.emit(event.data); // event.data: { fp: FinishedProductModel[], data: any }
        console.log('genLineItemsFromFinishedProducts', event);
        this.onClose.emit()
        break;
    }
  }

}
